module.exports = __webpack_public_path__ + "static/media/republic-logo.945006cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/republic-logo.png
// module id = 2810
// module chunks = 0